import { Form, Space, TimePicker } from 'antd';
import { FC } from 'react';
import RemindDays from '@/pages/backend/cardCampSettings/nodeSettings/remindDays';

const remindTime: FC = () => {
  const form = Form.useFormInstance();
  return (
    <Space>
      <div style={{ marginBottom: 24 }}>打卡营开营后第</div>
      <RemindDays />
      <div style={{ marginBottom: 24 }}>天的</div>
      <Form.Item name="remindTime">
        <TimePicker format={'HH:mm'} />
      </Form.Item>
    </Space>
  );
};
export default remindTime;
